import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';

import { OnsetExamDataDto } from '../../dtos/onset-exam-data-dto';

@Injectable({
    providedIn: 'root',
})
export class ConnectorAuthService {
    isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    onsetExamDataDto: BehaviorSubject<OnsetExamDataDto | null> = new BehaviorSubject<OnsetExamDataDto | null>(null);

    login(onsetExamDataDto: OnsetExamDataDto) {
        this.onsetExamDataDto.next(onsetExamDataDto);
        this.isLoggedIn.next(true);
    }

}
